export default "__VITE_ASSET__DLhfc$Nj__"